import React from "react";
import { API_URL } from "../../../config/api";

const PropertyImagePreview = ({
  imageFiles,
  images,
  editingProperty,
  onRemove,
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-3">
      {imageFiles.map(
        (file, index) => (
          <div
            key={index}
            className="relative"
          >
            <img
              src={URL.createObjectURL(
                file
              )}
              alt={`preview-${index}`}
              className="w-full h-32 object-cover border rounded"
            />

            <button
              type="button"
              onClick={() =>
                onRemove(index)
              }
              className="absolute top-1 right-1 bg-red-600 text-white rounded px-2 py-1 text-xs"
            >
              ✕
            </button>
          </div>
        )
      )}

      {editingProperty &&
        !imageFiles.length &&
        Array.isArray(images) &&
        images.map((img, index) => (
          <img
            key={index}
            src={
              img.startsWith("http")
                ? img
                : `${API_URL}${img}`
            }
            alt={`property-${index}`}
            className="w-full h-32 object-cover border rounded"
          />
        ))}
    </div>
  );
};

export default PropertyImagePreview;